import './KeyboardKey.css';
import classNames from 'classnames';
import type { FC, HTMLAttributes } from 'react';

export const KeyboardKey: FC<HTMLAttributes<HTMLSpanElement>> = ({
  className,
  ...props
}) => <span className={classNames('keyboard-key', className)} {...props} />;
